module.exports = __webpack_public_path__ + "static/sphere_logo-c7325115c4d3f738185d69f277a0fd88.png";